import { provideLocal } from '@vueuse/core';
import { usePageData } from '~/composables/usePageData';
import { useProduct } from '~/modules/product/composables/useProduct';
import {
  PRODUCT_FLAGS_REPOSITORY,
  PRODUCT_TOP_LEVEL_CATEGORY_FLAGS_REPOSITORY,
  PRODUCT_DIVISION_CATEGORY_FLAGS_REPOSITORY,
  PRODUCT_FEATURE_ELIGIBILITY_REPOSITORY,
} from '../../product/constants/providers';
import useIsolatedStickyAtbStateStore from '~/modules/sticky-product-traits/stores/useIsolatedStickyAtbStateStore';

export const useFlagsProvide = () => {
  const stickyAtbStore = useIsolatedStickyAtbStateStore();
  const {
    flags: { common: commonFlags, groupByProducts: groupByProductsFlags },
  } = usePageData();
  // common product flags - same for all products (i.e. master and member)
  const { topLevelCategoryFlags, divisionCategoryFlags } = commonFlags;
  // get flags by product Id
  const { productId } = useProduct();
  const { productFlags, featureEligibilityFlags } = ((groupByProductsFlags as Record<string, unknown>)?.[productId] ??
    stickyAtbStore.pageDataStickyAtbFlags?.[productId] ??
    {}) as {
    productFlags?: unknown;
    featureEligibilityFlags?: unknown;
  };

  provideLocal(PRODUCT_FLAGS_REPOSITORY, productFlags);
  provideLocal(PRODUCT_TOP_LEVEL_CATEGORY_FLAGS_REPOSITORY, topLevelCategoryFlags);
  provideLocal(PRODUCT_DIVISION_CATEGORY_FLAGS_REPOSITORY, divisionCategoryFlags);
  provideLocal(PRODUCT_FEATURE_ELIGIBILITY_REPOSITORY, featureEligibilityFlags);
};
